export const BASE_PATHNAME = '/my-purchases'
export const LOGIN_PATHNAME = `${BASE_PATHNAME}/login`
export const LOGIN_TAB_PATHNAME = `${LOGIN_PATHNAME}#login`
export const GUEST_TAB_PATHNAME = `${LOGIN_PATHNAME}#orderForm`
export const PURCHASE_DETAIL_PATHNAME = `${BASE_PATHNAME}/detail`
export const REGISTER_PATH = '/login?tab=register'
export const HOME_PATH = ''
